import React, { useCallback } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import M_FieldDateSet from 'components/1_Atoms/2_Molecules/M_FieldDateSetNew'
import M_FieldSelect from 'components/1_Atoms/2_Molecules/M_FieldSelect'
import M_ButtonSubmit from 'components/1_Atoms/2_Molecules/M_ButtonSubmit'
import M_FieldJuryo from 'components/1_Atoms/2_Molecules/M_FieldJuryo'
import M_FieldJuryoMobile from 'components/1_Atoms/2_Molecules/M_FieldJuryoMobile'
import { baseInfo } from 'types/SearchTypes'
import { useDate, useSearch, useTokuisaki, useTenpo, useJigyosho, useShohin, useDenpyoNo, useJuryo, useDetailView, useDateDetail, useTenpoDetail, useTokuisakiDetail, useShohinDetail, useJuryoDetail, useExpand, useExpandDetail } from 'hooks/useJuryo'
import { useUser } from 'hooks/useLogin'
import { useMediaQueryContext } from 'MediaQueryProvider'
import * as TableJuryoAction from 'slicers/TableSlicers/TableJuryoSlice'
import { useDispatch } from 'store'
import { SingleValue } from 'react-select'
import { Collapse } from '@material-ui/core'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      // height: window.innerHeight * 0.3,
    },
    grid: {
      flexGrow: 1,
    },
    box: {
      textAlign: 'left',
    },
    impotant: {
      color: '#FF0000',
    },
  }),
)

type Props = {
  info: baseInfo
}

const O_SearchBoxJuryo = ({ info }: Props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [isJapell] = useUser()
  const [detailView, _] = useDetailView()
  const [expand] = useExpand()
  const [expandDetail] = useExpandDetail()
  const [NOHIN_YMD_FROM, NOHIN_YMD_TO, changeFromDate, changeToDate] = useDate()
  const [TOKUI_CD, changeTokui] = useTokuisaki()
  const [TEN_CD, changeTenpo] = useTenpo()
  const [JIGYO_CD, changeJigyo] = useJigyosho()
  const [SHOHIN_CD, changeShohinCode] = useShohin()
  const [DENPYO_NO, changeDenpyoNo] = useDenpyoNo()
  const [
    mijuryoCheck, //
    juryoCheck,
    naiyoCheck,
    keppinCheck,
    changeMijuryoCheck,
    changeJuryoCheck,
    changeNaiyoCheck,
    changeKeppinCheck,
  ] = useJuryo()

  const [NOHIN_YMD_FROM_DETAIL, NOHIN_YMD_TO_DETAIL, _changeFromDateDetail, _changeToDateDetail] = useDateDetail()
  const [TOKUI_CD_DETAIL, _changeTokuiDetail] = useTokuisakiDetail()
  const [TEN_CD_DETAIL, _changeTenpoDetail] = useTenpoDetail()
  const [SHOHIN_CD_DETAIL, changeShohinCodeDetail] = useShohinDetail()
  const [
    mijuryoCheckDetail, //
    juryoCheckDetail,
    naiyoCheckDetail,
    keppinCheckDetail,
    _changeMijuryoCheckDetail,
    _changeJuryoCheckDetail,
    _changeNaiyoCheckDetail,
    _changeKeppinCheckDetail,
  ] = useJuryoDetail()

  const [clickReset, clickInputCSV, clickBack] = useSearch()
  const { isMobileSite } = useMediaQueryContext()

  const changeShohin = useCallback((targetValue: SingleValue<any>) => {
    // selectListをリセット
    dispatch(TableJuryoAction.format())
    changeShohinCodeDetail(targetValue)
  }, [])

  const xs = isMobileSite ? 12 : 4

  return (
    <Collapse in={detailView ? expandDetail : expand} timeout="auto">
      <div className={classes.root}>
        <Grid container spacing={1}>
          {/* //////////////////// 1 行目 //////////////////// */}
          <Grid item xs={xs} className={classes.grid}>
            {/* ==== 年月 ==== */}
            <M_FieldDateSet
              key1={1} //
              label="伝票日付"
              value1={detailView ? NOHIN_YMD_FROM_DETAIL : NOHIN_YMD_FROM}
              blurFunc1={detailView ? undefined : changeFromDate}
              disabled1={detailView}
              focus={false}
              key2={2}
              value2={detailView ? NOHIN_YMD_TO_DETAIL : NOHIN_YMD_TO}
              blurFunc2={detailView ? undefined : changeToDate}
              disabled2={detailView}
              type="date"
            />
          </Grid>
          {isMobileSite ? (
            <></>
          ) : (
            <Grid item xs={4}>
              {/* ==== 事業所 ==== */}
              {isJapell ? (
                <M_FieldSelect
                  label="事業所" //
                  valueCode={JIGYO_CD}
                  valueSet={info.jigyoList}
                  event={changeJigyo}
                />
              ) : (
                <></>
              )}
            </Grid>
          )}
          {isMobileSite ? (
            <></>
          ) : (
            <Grid item xs={4}>
              {/* -------- [ 検索条件リセット ] -------- */}
              <Grid container justifyContent="flex-end">
                {isJapell ? <M_ButtonSubmit label={'検索条件リセット'} event={clickReset} /> : <M_ButtonSubmit label={'CSV登録'} event={clickInputCSV} />}
              </Grid>
            </Grid>
          )}

          {/* //////////////////// 2 行目 //////////////////// */}
          <Grid item xs={xs}>
            {/* ==== 得意先 ==== */}
            <M_FieldSelect
              label="得意先" //
              valueCode={detailView ? TOKUI_CD_DETAIL : TOKUI_CD}
              valueSet={info.tokuiList}
              event={detailView ? undefined : changeTokui}
              disabled={detailView}
            />
          </Grid>
          {isMobileSite ? (
            <></>
          ) : (
            <Grid item xs={8}>
              {/* ==== 商品 ==== */}
              <M_FieldSelect
                label="商品" //
                valueCode={SHOHIN_CD}
                valueSet={info.shohinList}
                event={changeShohinCode}
              />
            </Grid>
          )}

          {/* //////////////////// 3 行目 //////////////////// */}
          <Grid item xs={xs} className={classes.grid}>
            {/* ==== 店舗 ==== */}
            <M_FieldSelect
              label="店舗" //
              valueCode={detailView ? TEN_CD_DETAIL : TEN_CD}
              valueSet={info.tenList}
              event={detailView ? undefined : changeTenpo}
              disabled={TOKUI_CD === '-1' || detailView}
            />
          </Grid>
          {isMobileSite ? (
            <Grid item xs={12}>
              {/* ==== 商品 ==== */}
              <M_FieldSelect
                label="商品" //
                valueCode={detailView ? SHOHIN_CD_DETAIL : SHOHIN_CD}
                valueSet={info.shohinList}
                event={detailView ? changeShohin : changeShohinCode}
              />
            </Grid>
          ) : (
            <Grid item xs={xs}>
              {/* ==== 伝票番号 ==== */}
              <M_FieldSelect
                label="伝票番号" //
                valueCode={DENPYO_NO}
                valueSet={info.denpyoNoList}
                event={changeDenpyoNo}
              />
            </Grid>
          )}
          {isMobileSite ? (
            <></>
          ) : (
            <Grid item xs={4}>
              {/* -------- [ 検索条件リセットボタン ] -------- */}
              <Grid container justifyContent="flex-end">
                {isJapell ? <></> : <M_ButtonSubmit label={'検索条件リセット'} event={clickReset} />}
              </Grid>
            </Grid>
          )}

          {/* //////////////////// 4 行目 //////////////////// */}
          <Grid item xs={12} className={classes.grid}>
            {/* ==== 受領区分 ==== */}
            {isMobileSite ? (
              <M_FieldJuryoMobile
                label={'受領区分'} //
                check1={detailView ? mijuryoCheckDetail : mijuryoCheck}
                check2={detailView ? juryoCheckDetail : juryoCheck}
                check3={detailView ? naiyoCheckDetail : naiyoCheck}
                check4={detailView ? keppinCheckDetail : keppinCheck}
                event1={detailView ? () => {} : changeMijuryoCheck}
                event2={detailView ? () => {} : changeJuryoCheck}
                event3={detailView ? () => {} : changeNaiyoCheck}
                event4={detailView ? () => {} : changeKeppinCheck}
                buttonLabel={detailView ? '戻る' : '検索条件リセット'}
                buttonEvent={detailView ? clickBack : clickReset}
                disabled={detailView}
              />
            ) : (
              <M_FieldJuryo
                label={'受領区分'} //
                check1={mijuryoCheck}
                check2={juryoCheck}
                check3={naiyoCheck}
                check4={keppinCheck}
                event1={changeMijuryoCheck}
                event2={changeJuryoCheck}
                event3={changeNaiyoCheck}
                event4={changeKeppinCheck}
              />
            )}
          </Grid>
        </Grid>
      </div>
    </Collapse>
  )
}
export default React.memo(O_SearchBoxJuryo)
